import { mapRecord } from "@base/util/TypeUtil";
import { ArticleInfo } from "@biz/articles/ArticleInfo";
import { IRuleArticle, IShoppingArticle, RuleArticleMap } from "@biz/definitions/ArticleDefinitions";
import { PoleId } from "@biz/definitions/SunSailDefinitions";
import { RuleArticleHelper } from "@biz/logic/RuleArticleHelper";
import { ShoppingCartPriority } from "@biz/models/ShoppingListDefinitions";

export class CalcArticlesHelper {

  static isArticleToBuyForDealer(a: IShoppingArticle): boolean {
    if ((a.count - (a.countClientAvailable || 0)) <= 0)
      return false;
    if (a.mul !== undefined && a.mul <= 0.0)
      return false;
    return true;
  }

  static isArticleToBuyForCustomer(a: { count: number, mul?: number}): boolean {
    if (a.count <= 0)
      return false;
    if (a.mul !== undefined && a.mul <= 0.0)
      return false;
    return true;
  }


  static isFrachtArticle(id: string): boolean {
    return id.startsWith("99FRACHT") || id === "99VERSANDKOSTEN";
  }

  static isAdditionalArticle(id: string): boolean {
    switch (id) {
      case "99MANIPUL": return true;
    }
    if (CalcArticlesHelper.isFrachtArticle(id))
      return true;
    return false;
  }

  static filterArticles(articles: IShoppingArticle[]): IShoppingArticle[] {
    if (!articles || articles.length === 0)
      return [];
    return articles.filter(CalcArticlesHelper.isArticleToBuyForCustomer)
  }

  static getShoppingList(articleMap: RuleArticleMap | undefined): IShoppingArticle[] {
    if (!articleMap)
      return [];

    const articles = CalcArticlesHelper.filterArticles(CalcArticlesHelper.ruleToShoppingArticles(articleMap))
    return articles;
  }

  static hasHoveringCap(articleMap: RuleArticleMap | undefined, poleId: PoleId): boolean {
    if (!articleMap)
      return false;
    return RuleArticleHelper.findPoleArticles(articleMap, ArticleInfo.getCoveringCapArticles().map((a) => a.id), poleId).length > 0;
  }

  static hasArticle(articleMap: RuleArticleMap | undefined, articleId: string, poleId: PoleId | undefined | -1): boolean {
    if (!articleMap)
      return false;
    return RuleArticleHelper.findPoleArticles(articleMap, [articleId], poleId).length > 0; // Raff PoleIndex | undefined | -1
  }

  static ruleToShoppingArticle(ra: IRuleArticle): IShoppingArticle {
    return {
      id: ra.id,
      articleNumber: ra.articleNumber,
      articlePrice: ra.articlePrice,
      articleType: ra.articleType,
      count: ra.count,
      articleGroup: ra.articleGroup,
      computed: ra.computed,
      additionalArticleInfo: ra.additionalArticleInfo,

      // todo
      countClientAvailable: ra.countClientAvailable,
      priceListIndex: ra.priceListIndex,
      mul: ra.mul,
      mulUnit: ra.mulUnit,
      stkUnit: ra.stkUnit,
      affiliation: ra.affiliation,
      powderCoating: ra.powderCoating,
      beosOrder: ra.beosOrder,
      features: ra.features,

      partList: ra.partList,
      quickOverlayPriority: ra.quickOverlayPriority,
      shoppingCartPriority: ra.shoppingCartPriority ?? (ShoppingCartPriority as any)[ra.articleNumber],
      offerList: ra.offerList,
      included: ra.included ? mapRecord(ra.included, CalcArticlesHelper.ruleToShoppingArticle) : undefined,

      customArticle: ra.customArticle,
    }
  }

  static ruleToShoppingArticles(ruleArticles: RuleArticleMap): IShoppingArticle[] {
    const shoppingArticles: IShoppingArticle[] = [];
    const keys = Object.keys(ruleArticles || {});
    for (const k of keys) {
      const article = ruleArticles[k];
      const a = CalcArticlesHelper.ruleToShoppingArticle(article);
      shoppingArticles.push(a);
    }

    return shoppingArticles;
  }
}